import classNames from "classnames"
import React from "react"

import { Button } from "../../Inputs/Button/Button"
import type { PNImageProps } from "../PNImage/PNImage"
import { PNImage } from "../PNImage/PNImage"

export type AppBannerProps = {
  id?: string
  title?: string | React.ReactNode
  subtitle?: string | React.ReactNode
  src?: PNImageProps["src"]
  ctaLabel: string
  ctaRel?: string
  ctaOnClick?: (ev: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void
  ctaHref: string
  className?: string
  imageClassName?: string
}

export const AppBanner = ({
  id,
  title,
  subtitle,
  src,
  ctaLabel,
  ctaHref,
  ctaRel,
  ctaOnClick,
  className,
  imageClassName,
}: AppBannerProps) => (
  <section id={id} className={classNames(className, "relative w-full bg-neutral-100")}>
    <div className="mx-auto flex w-full max-w-screen-xl flex-col sm:flex-row lg:justify-between">
      <div className="mr-auto mt-20 flex w-auto max-w-[590px] flex-col px-6 sm:my-20 xl:my-36 xl:pr-0">
        <h2 className="title-display">{title}</h2>
        <p className="subtitle mt-5 max-w-[410px] md:mt-6 xl:max-w-none">{subtitle}</p>
        <Button href={ctaHref} onClick={ctaOnClick} rel={ctaRel} color="primary" className="mt-7 md:mt-10 xl:mt-12">
          {ctaLabel}
        </Button>
      </div>
      {!!src && (
        <PNImage
          src={src}
          loading="lazy"
          className={classNames(
            "mx-auto h-auto max-h-[630px] shrink object-contain p-6 sm:max-w-[33%] lg:mx-0 lg:max-w-[50%]",
            imageClassName,
          )}
          quality={90}
        />
      )}
    </div>
  </section>
)
